/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaAudioMicAIcon20Regular = forwardRef('MediaAudioMicAIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 1a4 4 0 0 0-4 4v5a4 4 0 0 0 8 0V5a4 4 0 0 0-4-4ZM7.5 5a2.5 2.5 0 0 1 5 0v5a2.5 2.5 0 0 1-5 0V5Z" }),
        React.createElement("path", { d: "M4.25 8a.75.75 0 0 1 .75.75V10a5 5 0 0 0 10 0V8.75a.75.75 0 0 1 1.5 0V10a6.501 6.501 0 0 1-5.75 6.457V18h2.75a.75.75 0 0 1 0 1.5h-7a.75.75 0 0 1 0-1.5h2.75v-1.543A6.501 6.501 0 0 1 3.5 10V8.75A.75.75 0 0 1 4.25 8Z" })));
});
